export const UPDATE_MICRO_LOANS_SETTINGS_DATA_START =
  'UPDATE_MICRO_LOANS_SETTINGS_DATA_START';
export const UPDATE_MICRO_LOANS_SETTINGS_DATA_SUCCESS =
  'UPDATE_MICRO_LOANS_SETTINGS_DATA_SUCCESS';
export const UPDATE_MICRO_LOANS_SETTINGS_DATA_ERROR =
  'UPDATE_MICRO_LOANS_SETTINGS_DATA_ERROR';
